import { AnimatePaint } from './AnimatePaint'


export const TransitionList = {

    fill: AnimatePaint.paintTransition,

    stroke: AnimatePaint.paintTransition,

}